var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("my-asidebar", { attrs: { "active-tab": "coupon" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard-content-wrap" }, [
            _c(
              "div",
              {
                staticClass:
                  "dashboard-bread dashboard--bread dashboard-bread-2",
              },
              [
                _c("div", { staticClass: "container-fluid" }, [
                  _c("div", { staticClass: "row align-items-center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c("div", { staticClass: "breadcrumb-list text-right" }, [
                        _c("ul", { staticClass: "list-items" }, [
                          _c("li", [
                            _c(
                              "a",
                              {
                                staticClass: "text-white",
                                attrs: { href: _vm.basePath },
                              },
                              [_vm._v("Anasayfa")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("li", [_vm._v("Ödemeler")]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard-main-content" }, [
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("coupon-list")],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("use-coupon-popup"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-6" }, [
      _c("div", { staticClass: "breadcrumb-content" }, [
        _c("div", { staticClass: "section-heading" }, [
          _c("h2", { staticClass: "sec__title font-size-30 text-white" }, [
            _vm._v("Ödemeler"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }